<script>
import {cloneDeep, groupBy} from "lodash";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
    name: "MainTargetTemplate",
    components: {
        Multiselect,
    },
    props: {
        mainTargets: {
            type: Array,
            default: () => [],
        },
        mandatory: {
            type: Boolean,
            default: false,
        },
        fromTemplate: {
            type: Boolean,
            default: false,
        },
        singleSelection: {
            type: Boolean,
            default: false,
        },
        allowText: {
            type: Boolean,
            default: false,
        },
        mother: null,
    },
    data() {
        return {
            modalTitle: "",
            deliveryUnits: [],
            dus: [],
            deliveryUnit: {
                id: 0,
                description: "",
                target: 0,
                isPercentage: false,
            },
            submitted: false,
            duLoading: false,
            moreDU: {
                id: 0,
                planningMainTargetId: 0,
                description: null,
                q1: null,
                q2: null,
                q3: null,
                q4: null,
                points: null,
                allowEdit: false,
                cascadedTarget: null,
                deliveryUnit: null,
                popover: false,
                selectedDUs: [],
            },
            selectedDU: null,
            searchInput: '',
            selectedDUs: [],
            filterDU: '',
            currentPage: 1,
            perPage: 10,
        };
    },
    validations: {
        moreDU: {
            description: {
                required,
            },
            deliveryUnit: {
                required,
            },
            // points: {
            //     required,
            // },
        },
    },
    computed: {
        filteredTargets(){
            if(this.searchInput){
                return this.mainTargets.filter(x => x.description.toLowerCase().includes(this.searchInput.toLowerCase()));
            }
            return this.mainTargets;
        },
        checkAllDU: {
            get() {
                return this.dus.length > 0 && this.selectedDUs.length === this.dus.length;
            },
            set(value) {
                if (value) {
                    this.selectedDUs = this.dus.map(x => x);
                } else {
                    this.selectedDUs = [];
                }
            },
        },
        formatDUs(){
            let data = this.dus;
            if(this.filterDU.trim() != "" && this.filterDU){
                data = data.filter(x => x.name.toLowerCase().includes(this.filterDU.toLowerCase()));
            }
            return data;
        },
    },
    methods: {
        async toggleDeliveryUnits(row, fromParent = false) {
            if(!fromParent){
                row.visible = !row.visible;
            }else{
                row.visible = true;
            }
            if(row.visible){
                row.loadDU = true;
                await this.getPlanningTemplateDUs(row);
                row.loadDU = false;
            }
        },
        toggleMandatoryApis(row){
            row.mandatoryVisible = !row.mandatoryVisible;
            if(row.mandatoryVisible){
                this.getPriorityApi(row);
            }
        },
        async getPriorityApi(row){
            this.pageLoader(true);
            await this.$store.dispatch("targettemplatepriorityapi/GetTargetTemplatePriorityApiByMainTarget", row.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.targetTemplatePriorityApis.forEach(x => {
                        let index = res.data.findIndex(y => y.priorityApiTemplateId == x.id);
                        if(index > -1){
                            x.selected = true;
                            x.priorityId = res.data[index].id
                        }else{
                            x.selected = false;
                        }
                    })
                    row.priorityApis = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong! - getting priority apis", "error");
                });
            this.pageLoader(false);
        },
        async getDUs(id, row) {
            this.duLoading = true;
            this.pageLoader(true);
            await this.$store
                .dispatch("deliveryunit/GetDeliveryUnitByCampus", id)
                .then((res) => {
                    let dus = [];
                    if (row) {
                        res.data.forEach((item) => {
                            let exist = row.targetDUs.findIndex((x) => x.deliveryUnitId == item.id);
                            if (exist < 0) { dus.push(item); }
                        });
                    } else {
                        dus = res.data;
                    }
                    this.dus = dus;
                    this.duLoading = false;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong! - getting DUs",
                        "error"
                    );
                });
            this.pageLoader(false);
        },
        addMoreDU(x) {
            this.upZed(x);
            x.addDU = true;
            this.getDUs(this.$store.state.data.selectedCampus.id, x);
            this.onResetDU(x);
            x.targetDUs.forEach((item) => {
                item.editMode = false;
            });
            x.targetTemplateDeliveryUnits = this.filteredDU(x.targetDUs);
            this.selectedDUs = [];
        },
        singleAddDU(row) {
            if (row.deliveryUnitId > 0) {
                row.du = this.dus.find((x) => x.id == row.deliveryUnitId);
            }
        },
        onResetDU(row){
            this.moreDU = {
                id: 0,
                deliveryUnitId: "",
                planningMainTargetId: cloneDeep(row.id),
                description: row.description,
                q1: "0",
                q2: "0",
                q3: "0",
                q4: "0",
                points: "0",
                allowEdit: false,
                cascadedTarget: row.overAllTarget.toString(),
                deliveryUnit: null,
                popover: false,
                selectedDUs: [],
            };
            this.$v.moreDU.$reset();
        },
        async saveSingleDU(row) {
            this.submitted = true;
            if(this.moreDU.selectedDUs.length){
                this.moreDU.deliveryUnit = this.moreDU.selectedDUs[0];
            }
            this.$v.moreDU.$touch();
            if (this.$v.moreDU.$invalid) {
                return;
            }
            if(this.allowText){
                if(!this.moreDU.q1Text || !this.moreDU.q2Text || !this.moreDU.q3Text || !this.moreDU.q4Text || !this.moreDU.cascadedTargetText){
                    return;
                }
            }else{
                if(!this.moreDU.q1 || !this.moreDU.q2 || !this.moreDU.q3 || !this.moreDU.q4 || !this.moreDU.cascadedTarget){
                    return;
                }
            }
            let data = cloneDeep(this.moreDU);
            data.cascadedTarget = this.getExactAmt(data.cascadedTarget || "0");
            data.q1 = this.getExactAmt(data.q1 || "0");
            data.q2 = this.getExactAmt(data.q2 || "0");
            data.q3 = this.getExactAmt(data.q3 || "0");
            data.q4 = this.getExactAmt(data.q4 || "0");
            data.points = this.getExactAmt(data.points || "0");
            data.deliveryUnitId = this.moreDU.deliveryUnit.id;
            data.deliveryUnit = this.moreDU.deliveryUnit;
            if(this.fromTemplate){
                data.planningTemplateMainTargetId = this.moreDU.planningMainTargetId;
                for await(const du of data.selectedDUs){
                    try{
                        data.deliveryUnitId = du.id;
                        data.deliveryUnit = du;
                        const { data: res } = await this.$store.dispatch("planningtemplatedu/CreatePlanningTemplateDeliveryUnit", data);
                        if (res.error) {
                            this.showToast(res.errorMessage, "error");
                            continue;
                        }
                        res.deliveryUnit = this.dus.find((x) => x.id == res.deliveryUnitId);
                        this.dus.splice(this.dus.indexOf(res.deliveryUnit), 1);
                        row.addDU = false;
                        res.editMode = false;
                        res.campusId = this.$store.state.data.selectedCampus.id;
                        res.campusName = this.$store.state.data.selectedCampus.campusName;
                        res.viewDUs = false;
                        row.targetDUs.push(res);
                    }catch(err){
                        this.showToast("Something went wrong! - adding DU", "error");
                    }
                }
                this.showToast("Successfully added!", "success");
                row.targetTemplateDeliveryUnits = this.filteredDU(row.targetDUs, this.$store.state.data.selectedCampus.id);
                
                // this.$store
                //     .dispatch(
                //         "planningtemplatedu/CreatePlanningTemplateDeliveryUnit",
                //         data
                //     )
                //     .then((res) => {
                //         if (res.data.error) {
                //             return this.showToast(res.data.errorMessage, "error");
                //         }
                //         res.data.deliveryUnit = this.dus.find((x) => x.id == res.data.deliveryUnitId);
                //         this.dus.splice(this.dus.indexOf(res.data.deliveryUnit), 1);
                //         row.addDU = false;
                //         res.data.editMode = false;
                //         res.data.campusId = this.$store.state.data.selectedCampus.id;
                //         res.data.campusName = this.$store.state.data.selectedCampus.campusName;
                //         res.data.viewDUs = false;
                //         row.targetDUs.push(res.data);
                //         row.targetTemplateDeliveryUnits = this.filteredDU(row.targetDUs, this.$store.state.data.selectedCampus.id);
                //     })
                //     .catch((err) => {
                //         this.showToast("Something went wrong!", "error");
                //     });
            }else{
                this.$store
                    .dispatch(
                        "planningtarget/CreatePlanningTarget",
                        data
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.deliveryUnit = this.dus.find(
                            (x) => x.id == res.data.deliveryUnitId
                        );
                        this.dus.splice(this.dus.indexOf(res.data.deliveryUnit), 1);
                        row.addDU = false;
                        res.data.editMode = false;
                        res.data.viewDUs = false;
                        row.targetDUs.push(res.data);
                        row.targetTemplateDeliveryUnits = this.filteredDU(row.targetDUs, this.$store.state.data.selectedCampus.id);
                        this.showToast("Successfully added!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            
        },
        async getPlanningTemplateDUs(row){
            if(this.fromTemplate){
                await this.$store
                    .dispatch(
                        "planningtemplatedu/GetPlanningTemplateDeliveryUnit",
                        {id: row.id, cycle: this.$store.state.data.cycle}
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map(item => {
                            item.editMode = false;
                        })
                        row.targetDUs = cloneDeep(res.data);
                        row.targetTemplateDeliveryUnits = this.filteredDU(res.data);
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                await this.$store
                    .dispatch("planningtarget/GetAllPlanningTarget", row.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map(item => {
                            item.editMode = false;
                        })
                        row.targetDUs = cloneDeep(res.data);
                        row.targetTemplateDeliveryUnits = this.filteredDU(res.data);
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        updateTargetDU(x, y) {
            this.getDUs(this.$store.state.data.selectedCampus.id, x);
            x.addDU = false;
            x.targetDUs.forEach((item) => {
                item.editMode = false;
            });
            x.targetTemplateDeliveryUnits = this.filteredDU(x.targetDUs, this.$store.state.data.selectedCampus.id);
            y.editMode = true;
            this.moreDU = cloneDeep(y);
        },
        cancelTargetDU(y) {
            y.editMode = false;
            y.q1 = cloneDeep(this.moreDU.q1);
            y.q2 = cloneDeep(this.moreDU.q2);
            y.q3 = cloneDeep(this.moreDU.q3);
            y.q4 = cloneDeep(this.moreDU.q4);
            y.points = cloneDeep(this.moreDU.points);
            y.cascadedTarget = cloneDeep(this.moreDU.cascadedTarget);
            y.description = cloneDeep(this.moreDU.description);
            y.deliveryUnitId = cloneDeep(this.moreDU.deliveryUnitId);
        },
        removeTargetDU(x, y) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    if(this.fromTemplate){
                        this.$store
                            .dispatch(
                                "planningtemplatedu/DeletePlanningTemplateDeliveryUnit",
                                y.id
                            )
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                x.targetDUs.splice(x.targetDUs.indexOf(y), 1);
                                x.targetTemplateDeliveryUnits = this.filteredDU(x.targetDUs, this.$store.state.data.selectedCampus.id);
                                this.showToast("Successfully deleted!", "success");
                            })
                            .catch((err) => {
                                this.showToast("Cannot be deleted!", "error");
                            });
                    }else{
                        this.$store
                            .dispatch(
                                "planningtarget/DeletePlanningTarget",
                                y.id
                            )
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                x.targetDUs.splice(x.targetDUs.indexOf(y), 1);
                                x.targetTemplateDeliveryUnits = this.filteredDU(x.targetDUs, this.$store.state.data.selectedCampus.id);
                                this.showToast("Successfully deleted!", "success");
                            })
                            .catch((err) => {
                                this.showToast("Cannot be deleted!", "error");
                            });
                    }
                    
                }
            });
        },
        deleteItem(row){
            this.$emit('delete', row);
        },
        updateItem(row){
            this.$emit('update', row);
        },
        postItem(row, parent){
            row.mainTargetId = parent.id;
            this.$emit('post', row);
        },
        postSingle(row){
            let tempData = {
                mainTargetId: row.planningTemplateMainTargetId,
                dus: [row],
                campusId: row.campusId,
            }
            this.$emit('post', tempData);
        },
        saveDUPoint(row){
            let data = cloneDeep(row);
            data.deliveryUnitId = cloneDeep(row.deliveryUnit.id);
            if(this.fromTemplate){
                this.$store
                    .dispatch(
                        "planningtemplatedu/UpdatePlanningTemplateDeliveryUnit",
                        data
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.editMode = false;
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                this.$store
                    .dispatch(
                        "planningtarget/UpdatePlanningTarget",
                        data
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.editMode = false;
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            
        },
        updateMandatoryApis(row, parentId){
            if(row.selected){
                this.$store
                .dispatch(
                    "targettemplatepriorityapi/CreateMultipleTargetTemplatePriorityApi",
                    {
                        planningMainTargetId: parentId,
                        priorityApiTemplateIds: [row.id]
                    }
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
            }else{
                this.$store
                .dispatch(
                    "targettemplatepriorityapi/DeleteTargetTemplatePriorityApi",
                    row.priorityId
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
            }
        },
        openImports(row){
            this.$emit('open-imports', row);
        },
        viewAPIs(row){
            this.$emit('view-apis', row);
        },
        viewRubric(row){
            this.$emit('view-rubric', row);
        },
        calculateAnnualTarget(row, parent){
            if (!parent.isPercentage) {
                let total =
                    parseFloat(row.q1 ? row.q1 : 0) +
                    parseFloat(row.q2 ? row.q2 : 0) +
                    parseFloat(row.q3 ? row.q3 : 0) +
                    parseFloat(row.q4 ? row.q4 : 0);
                row.cascadedTarget = total.toString();
            } else {
                let ave = 0;
                if (parseFloat(row.q1 ? row.q1 : 0) != 0) ave = parseFloat(row.q1);
                if (parseFloat(row.q2 ? row.q2 : 0) != 0) ave = parseFloat(row.q2);
                if (parseFloat(row.q3 ? row.q3 : 0) != 0) ave = parseFloat(row.q3);
                if (parseFloat(row.q4 ? row.q4 : 0) != 0) ave = parseFloat(row.q4);
                row.cascadedTarget = ave.toString();
            }
        },
        filteredDU(dus, campusId = 0){
            let grp = [];
            let groupCampus = groupBy(dus, 'campusId');
            for(let key in groupCampus){
                let obj = {
                    campus: groupCampus[key][0].campusName,
                    viewDUs: campusId == key ? true : false,
                    campusId: key,
                    dus: groupCampus[key]
                }
                grp.push(obj);
            }
            return grp;
        },
        showPost(campus){
            let posted = campus.dus.filter(x => x.status != null);
            return posted.length == campus.dus.length ? false : true;
        },
        upZed(target){
            this.mainTargets.map(item => {
                item.zIndex = 0;
            })
            target.zIndex = 1;
        },
        viewDeliveryUnits(campus){
            campus.viewDUs = !campus.viewDUs;
            this.$forceUpdate();
        },
        addSelectedDUs(){
            this.moreDU.selectedDUs = JSON.parse(JSON.stringify(this.selectedDUs));
            this.moreDU.popover = false;
        },
    }
}

</script>
<template>
    <div class="card-body px-0 py-1">
        <div v-if="mainTargets.length == 0" class="my-5 text-center">
            <i class="bx bx-file-blank text-secondary font-size-24"></i>
            <h5 class="text-secondary">No target created yet</h5>
        </div>
        <div v-else class="mt-3">
            <div class="mb-2 w-300px">
                <input type="text" class="form-control" v-model="searchInput" placeholder="Search Targets...">
            </div>
            <b-card
                no-body
                class="mb-1 shadow-none"
                v-for="(x, index) in filteredTargets"
                :key="x.id"
                :style="{zIndex: x.zIndex}"
            >
                <b-card-header
                    header-tag="header"
                    role="tab"
                    class="border"
                >
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <template v-if="singleSelection">
                                <div
                                    style="min-width: 30px;"
                                    class="bg-purple bg-gradient text-center me-2 py-1 position-relative"
                                >
                                    <h3 class="mb-0 position-relative text-white">
                                        {{ index + 1}}
                                    </h3>
                                </div>
                            </template>
                            <div class="text-muted">
                                <div class="d-flex">
                                    <div class="form-check form-checkbox-outline form-check-success mb-0" v-if="!singleSelection">
                                        <input
                                            type="checkbox"
                                            :id="`main-targ-${x.id}`"
                                            checked="checked"
                                            class="form-check-input"
                                            v-model="x.selectedTarget"
                                            @change="$emit('selectTarget', {id: x.id, type: $event})"
                                        /><label
                                            :for="`main-targ-${x.id}`"
                                            class="form-check-label"
                                        >
                                            <h5 class="mb-1">{{x.description}}</h5>
                                        </label>
                                    </div>
                                    <h5 class="mb-1" v-else>{{x.description}}</h5>
                                </div>
                                <div>
                                    <small class="d-flex align-items-center">
                                        <b class="me-2">Target: {{`${allowText ? x.overAllTargetText || '' : x.overAllTarget || '0'} ${x.isPercentage ? '%' : ''}`}}</b>
                                        |
                                        <a
                                            href="javascript: void(0);"
                                            class="text-success d-flex align-items-center ms-2"
                                            @click="toggleDeliveryUnits(x)"
                                        >
                                            <b class="d-flex align-items-center">{{ x.visible ? "Hide" : "Show" }}
                                                Delivery Units
                                                <i 
                                                    class="bx bx-chevron-right rotate font-size-14"
                                                    :class="{'rotate-90': x.visible}"
                                                ></i>
                                            </b>
                                        </a>
                                        <template v-if="fromTemplate">
                                        |
                                        <a
                                            href="javascript: void(0);"
                                            class="text-info d-flex align-items-center ms-2"
                                            @click="viewRubric(x)"
                                        >
                                            <b>View Performance Rubric</b>
                                        </a>
                                        </template>
                                        <div class="d-flex align-items-center ms-2" v-if="mandatory">
                                        |
                                        <a
                                            href="javascript: void(0);"
                                            class="text-yellow d-flex align-items-center mx-2"
                                            @click="toggleMandatoryApis(x)"
                                        >
                                            Manage Priority API's
                                        </a>
                                        </div>
                                        <div class="d-flex align-items-center">
                                        <!-- |
                                        <a
                                            href="javascript: void(0);"
                                            class="
                                                text-light-purple
                                                d-flex
                                                align-items-center
                                                ms-2
                                            "
                                            @click="openImports(x)"
                                        >
                                            <b><i class="bx bx-download"></i> Import Targets</b>
                                        </a> -->
                                        </div>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div
                            class="
                                float-end
                                d-flex
                                align-items-center
                            "
                        >
                            <a href="javascript:void(0);" :id="`mt-${x.id}`">
                                <i class="fas fa-ellipsis-v"></i>
                            </a>
                            <b-popover
                                :target="`mt-${x.id}`"
                                triggers="click blur"
                                placement="bottomleft"
                                custom-class="dropdown-popover"
                            >
                                <ul style="list-style:none;padding:0;margin:0">
                                    <li @click="updateItem(x)">
                                        <a href="javascript:void(0);" class="dropdown-item text-dark">
                                            <i class="mdi mdi-update font-size-18 me-1"></i>Edit
                                        </a>
                                    </li>
                                    <li @click="deleteItem(x)">
                                        <a href="javascript:void(0);" class="dropdown-item text-danger">
                                            <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete
                                        </a>
                                    </li>
                                    <li @click="$emit('post', x)" v-if="!fromTemplate && (!x.status || x.status.toUpperCase() !== 'POSTED')">
                                        <a href="javascript:void(0);" class="dropdown-item text-success">
                                            <i class="bx bx-paper-plane font-size-18 me-1"></i>Post
                                        </a>
                                    </li>
                                </ul>
                            </b-popover>
                        </div>
                    </div>
                    <b-collapse
                        :visible="x.mandatoryVisible"
                        :accordion="`mandatory-accordion-${x.id}`"
                        role="tabpanel"
                    >
                        <hr class="mb-2">
                        <div class="d-inline-block">
                            <label for="priorityApi" class="text-warning"
                                >Priority API/s:
                            </label>
                            <span class="mx-3">-</span>
                            <div
                                class="
                                    form-check
                                    form-checkbox-outline
                                    form-check-success
                                    mb-0
                                    me-3
                                    d-inline-block
                                "
                                v-for="y in x.mandatoryApis" 
                                :key="`mandatory-${y.id}`"
                            >
                                <input
                                    type="checkbox"
                                    :id="`mandatoryCheckBox${y.id}`"
                                    class="
                                        form-check-input
                                    "
                                    v-model="
                                        y.selected
                                    "
                                    @change="updateMandatoryApis(y, x.id)"
                                />
                                <label :for="`mandatoryCheckBox${y.id}`" class="hoverable-link cursor-pointer">{{y.name}}</label>
                            </div>
                        </div>
                    </b-collapse>
                </b-card-header>
                <b-collapse
                    :visible="x.visible"
                    :accordion="`detail-accordion-${x.id}`"
                    role="tabpanel"
                >
                    <b-card-body
                        class="border"
                    >
                        <table class="table table-bordered">
                            <thead>
                                <tr class="bg-success bg-gradient">
                                    <th colspan="2">
                                        <div
                                            class="
                                                d-flex
                                                align-items-center
                                                text-white
                                            "
                                        >
                                            Target Description/Delivery Unit
                                            <button
                                                type="button"
                                                class="
                                                    btn
                                                    btn-warning
                                                    btn-sm
                                                    px-2
                                                    py-0
                                                    ms-1
                                                "
                                                @click="
                                                    addMoreDU(x)
                                                "
                                                v-if="!x.addDU"
                                            >
                                                <i
                                                    class="
                                                        bx
                                                        bx-plus
                                                    "
                                                ></i
                                                >Add More&nbsp;
                                            </button>
                                        </div>
                                    </th>
                                    <th
                                        class="text-center text-white"
                                        colspan="4" 
                                        rowspan="2"
                                    >
                                        Quarterly Targets
                                    </th>
                                    <th
                                        width="150px"
                                        class="text-center text-white" 
                                        rowspan="2"
                                    >
                                        Annual Target
                                    </th>
                                    <th
                                        width="120px"
                                        class="text-center text-white" 
                                        rowspan="2"
                                    >
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="x.loadDU">
                                    <td colspan="100%">
                                        <div
                                            class="
                                                d-flex
                                                justify-content-center
                                                align-items-center
                                            "
                                        >
                                            <div class="preloader-component me-2">
                                                <div class="status">
                                                    <div
                                                        class="
                                                            spinner-chase
                                                            w-20px
                                                            h-20px
                                                        "
                                                    >
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <strong>Loading...</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        v-if="!x.loadDU && x.targetTemplateDeliveryUnits.length == 0 && !x.addDU"
                                        colspan="100%"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-center
                                                align-items-center
                                            "
                                        >
                                            <strong>No Data Found</strong>
                                        </div>
                                    </td>
                                </tr>
                                <template v-if="!x.loadDU && x.addDU">
                                    <tr>
                                        <td rowspan="2" colspan="2">
                                            <div>
                                                <small>Delivery Unit:</small>
                                                <!-- <multiselect
                                                    v-model="
                                                        moreDU.deliveryUnit
                                                    "
                                                    :options="dus"
                                                    placeholder="Select one Delivery Unit"
                                                    label="name"
                                                    track-by="id"
                                                    selectLabel=""
                                                    deselectLabel=""
                                                    :class="{
                                                        'is-invalid':
                                                            submitted &&
                                                            $v
                                                                .moreDU
                                                                .deliveryUnit
                                                                .$error,
                                                    }"
                                                ></multiselect> -->
                                                <div class="form-control" id="select-du">
                                                    <template v-if="!moreDU.selectedDUs.length">
                                                        Select one or more Delivery Units
                                                    </template>
                                                    <template v-else>
                                                        <div v-for="du in moreDU.selectedDUs" :key="du.id">
                                                            {{ du.name }}
                                                        </div>
                                                    </template>
                                                </div>
                                                <b-popover
                                                    :target="`select-du`"
                                                    triggers="click"
                                                    placement="bottom"
                                                    :show.sync="moreDU.popover"
                                                    custom-class="popover-supplier"
                                                >
                                                    <template v-slot:title>
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                            "
                                                        >
                                                            <small>Add More Delivery Units</small>
                                                            <span 
                                                                class="bx bx-x font-size-14 cursor-pointer"
                                                                @click="moreDU.popover = false"
                                                            ></span>
                                                        </div>
                                                    </template>
                                                    <div :style="{fontSize: '0.9rem !important'}">
                                                        <div class="d-flex align-items-center justify-content-between pb-1 border-bottom">
                                                            <div
                                                                class="
                                                                    form-check
                                                                    form-checkbox-outline
                                                                    form-check-success
                                                                "
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    id="checkAllDU"
                                                                    class="form-check-input"
                                                                    v-model="checkAllDU"
                                                                /><label
                                                                    for="checkAllDU"
                                                                    class="form-check-label"
                                                                >
                                                                    Select All Delivery Units
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <input type="text" class="form-control form-control-sm" placeholder="Search Delivery Unit..." v-model="filterDU"/>
                                                            </div>
                                                        </div>
                                                        <div class="mt-1 savings-record">
                                                            <div
                                                                class="
                                                                    form-check
                                                                    form-checkbox-outline
                                                                    form-check-success
                                                                    mb-0
                                                                "
                                                                v-for="du in formatDUs"
                                                                :key="du.id"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    :id="`checkDU${du.id}`"
                                                                    class="form-check-input"
                                                                    v-model="selectedDUs"
                                                                    :value="du"
                                                                /><label
                                                                    :for="`checkDU${du.id}`"
                                                                    class="form-check-label"
                                                                >
                                                                    {{ du.name }}
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="border-top mt-1 pt-2 text-right" v-if="selectedDUs.length">
                                                            <button
                                                                class="btn btn-sm btn-success"
                                                                @click="addSelectedDUs"
                                                            >
                                                                <i class="bx bx-check me-1"></i>Add Selected
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-secondary ms-1"
                                                                @click="moreDU.popover = false"
                                                            >
                                                                <i class="bx bx-x me-1"></i>Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                                <small>Description:</small>
                                                <textarea
                                                    type="text"
                                                    class="
                                                        form-control
                                                    "
                                                    rows="2"
                                                    v-model="moreDU.description"
                                                    :class="{'is-invalid': submitted && $v.moreDU.description.$error}"
                                                ></textarea>
                                            </div>
                                        </td>
                                        <!-- <td class="align-middle">
                                            <input
                                                type="text"
                                                class="
                                                    form-control
                                                    text-center
                                                "
                                                v-model="moreDU.points"
                                                :class="{'is-invalid': submitted && $v.moreDU.points.$error}"
                                            />
                                        </td> -->
                                        <template v-if="allowText">
                                            <td colspan="4">
                                                <div class="mb-2" v-for="x in 4" :key="x">
                                                    <input
                                                        type="text"
                                                        class="
                                                            form-control
                                                            text-center
                                                        "
                                                        :placeholder="`Quarter ${x}`"
                                                        v-model="moreDU[`q${x}Text`]"
                                                        :class="{'is-invalid': submitted && !moreDU[`q${x}Text`]}"
                                                    />
                                                </div>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td class="align-middle" style="width: 100px">
                                                <input
                                                    type="text"
                                                    class="
                                                        form-control
                                                        text-center
                                                    "
                                                    placeholder="Q1"
                                                    v-model="moreDU.q1"
                                                    @input="calculateAnnualTarget(moreDU, x)"
                                                    :class="{'is-invalid': submitted && !moreDU.q1}"
                                                />
                                            </td>
                                            <td class="align-middle" style="width: 100px">
                                                <input
                                                    type="text"
                                                    class="
                                                        form-control
                                                        text-center
                                                    "
                                                    placeholder="Q2"
                                                    v-model="moreDU.q2"
                                                    @input="calculateAnnualTarget(moreDU, x)"
                                                    :class="{'is-invalid': submitted && !moreDU.q2}"
                                                />
                                            </td>
                                            <td class="align-middle" style="width: 100px">
                                                <input
                                                    type="text"
                                                    class="
                                                        form-control
                                                        text-center
                                                    "
                                                    placeholder="Q3"
                                                    v-model="moreDU.q3"
                                                    @input="calculateAnnualTarget(moreDU, x)"
                                                    :class="{'is-invalid': submitted && !moreDU.q3}"
                                                />
                                            </td>
                                            <td class="align-middle" style="width: 100px">
                                                <input
                                                    type="text"
                                                    class="
                                                        form-control
                                                        text-center
                                                    "
                                                    placeholder="Q4"
                                                    v-model="moreDU.q4"
                                                    @input="calculateAnnualTarget(moreDU, x)"
                                                    :class="{'is-invalid': submitted && !moreDU.q4}"
                                                />
                                            </td>
                                        </template>
                                        <td :class="[allowText ? 'align-start': 'align-middle']">
                                            <input
                                                type="text"
                                                class="form-control text-center"
                                                v-model="moreDU.cascadedTarget"
                                                :class="{'is-invalid': submitted && !moreDU.cascadedTarget}"
                                                v-if="!allowText"
                                            />
                                            <textarea
                                                placeholder="Annual Target"
                                                rows="6"
                                                type="text"
                                                class="
                                                    form-control
                                                    text-center
                                                "
                                                v-model="moreDU.cascadedTargetText"
                                                :class="{'is-invalid': submitted && !moreDU.cascadedTargetText}"
                                                v-else
                                            ></textarea>
                                        </td>
                                        <td class="align-middle" rowspan="2">
                                            <div
                                                class="
                                                    d-flex
                                                    justify-content-center
                                                    align-items-center
                                                "
                                            >
                                                <button
                                                    type="button"
                                                    class="
                                                        btn btn-link
                                                        p-0
                                                        me-1
                                                        text-success
                                                        d-flex
                                                        me-2
                                                    "
                                                    title="Save"
                                                    @click="saveSingleDU(x)"
                                                >
                                                    <i
                                                        class="
                                                            bx
                                                            bx-save
                                                            me-1
                                                            font-size-16
                                                        "
                                                    ></i
                                                    >Save
                                                </button>
                                                <button
                                                    type="button"
                                                    class="
                                                        btn btn-link
                                                        p-0
                                                        me-1
                                                        d-flex
                                                        align-items-center
                                                        text-dark
                                                    "
                                                    title="Cancel"
                                                    @click="
                                                        x.addDU = false
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            bx bx-x
                                                            me-1
                                                            font-size-16
                                                        "
                                                    ></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" class="border-success border-start-0 border-top-0 border-end-0 border-bottom-2">
                                            <div
                                                class="
                                                    form-check
                                                    form-checkbox-outline
                                                    form-check-success
                                                    mb-0
                                                "
                                            >
                                                <input
                                                    type="checkbox"
                                                    id="customCheckcolor2"
                                                    checked="checked"
                                                    class="form-check-input"
                                                    v-model="moreDU.allowEdit"
                                                /><label
                                                    for="customCheckcolor2"
                                                    class="form-check-label"
                                                >
                                                    Allow Edit
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="!x.loadDU && x.targetTemplateDeliveryUnits.length">
                                    <template  v-for="z in x.targetTemplateDeliveryUnits">
                                        <tr :key="`A${x.id}-B${z.campusId}-campus`">
                                            <td colspan="100%">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div @click="viewDeliveryUnits(z)">
                                                        <h5 class="text-info font-weight-bold cursor-pointer hover-underline mb-0">{{ z.campus }}</h5>
                                                        <small>Click to view delivery units</small>
                                                    </div>
                                                    <button 
                                                        type="button" 
                                                        @click="postItem(z, x)" 
                                                        class="btn btn-sm btn-success me-2" 
                                                        v-if="fromTemplate && showPost(z) && $store.state.data.selectedCampus.id == z.campusId"
                                                    >
                                                        <i class="bx bx-paper-plane"></i> Post
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <template v-if="z.viewDUs">
                                            <template v-for="(y, yIndex) in z.dus">
                                                <tr
                                                
                                                    :key="`A${x.id}-B${z.campusId}-C${y.id}`"
                                                >
                                                    <td style="width:30px;" rowspan="2" ></td>
                                                    <td class="align-middle border-2-white" :class="{'border-2-white-top' : yIndex == 0}" rowspan="2">
                                                        <div
                                                            style="line-height: 14px;"
                                                            class="d-flex align-items-center"
                                                            v-if="!y.editMode"
                                                        >
                                                            <b class="text-warning">{{y.deliveryUnit.name}}</b>
                                                            <!-- <button type="button" class="btn btn-warning btn-sm px-2 py-0 ms-1" @click="viewAPIs(y)">View API's</button> -->
                                                            <!-- <button type="button" class="btn btn-primary btn-sm px-2 py-0 ms-1">View Performance Rubric</button> -->
                                                        </div>
                                                        <div v-else>
                                                            <small>Delivery Unit:</small>
                                                            <multiselect
                                                                v-model="y.deliveryUnit"
                                                                :options="dus"
                                                                placeholder="Select one Delivery Unit"
                                                                label="name"
                                                                track-by="id"
                                                                selectLabel=""
                                                                deselectLabel=""
                                                            ></multiselect>
                                                        </div>
                                                        <hr class="my-2">
                                                        <small>Description:</small>
                                                        <div v-if="!y.editMode">
                                                            <span class="text-white" style="font-weight:500">{{ y.description }}</span>
                                                        </div>
                                                        <div v-else>
                                                            <textarea
                                                                rows="1"
                                                                type="text"
                                                                class="form-control"
                                                                v-model="y.description"
                                                            />
                                                        </div>
                                                    </td>
                                                    <template v-if="allowText">
                                                        <td colspan="4" :class="{'border-2-white-top' : yIndex == 0}">
                                                            <div class="mb-2"  v-for="x in 4" :key="x">
                                                                <div v-if="!y.editMode">
                                                                   Quarter {{ x }}:<span class="text-warning"> {{ y[`q${x}Text`] }}</span>
                                                                </div>
                                                                <div v-else>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control text-center"
                                                                        v-model="y[`q${x}Text`]"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </template>
                                                    <template v-else>
                                                        <td
                                                            class="text-center align-middle"
                                                            :class="{'border-2-white-top' : yIndex == 0}"
                                                            width="120px"
                                                        >
                                                            <div v-if="!y.editMode">
                                                                {{ y.q1 }}
                                                            </div>
                                                            <div v-else>
                                                                <input
                                                                    type="text"
                                                                    class="form-control text-center"
                                                                    @input="calculateAnnualTarget(y, x)"
                                                                    v-model="y.q1"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="text-center align-middle"
                                                            :class="{'border-2-white-top' : yIndex == 0}"
                                                            width="120px"
                                                        >
                                                            <div v-if="!y.editMode">
                                                                {{ y.q2 }}
                                                            </div>
                                                            <div v-else>
                                                                <input
                                                                    type="text"
                                                                    class="form-control text-center"
                                                                    @input="calculateAnnualTarget(y, x)"
                                                                    v-model="y.q2"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="text-center align-middle"
                                                            :class="{'border-2-white-top' : yIndex == 0}"
                                                            width="120px"
                                                        >
                                                            <div v-if="!y.editMode">
                                                                {{ y.q3 }}
                                                            </div>
                                                            <div v-else>
                                                                <input
                                                                    type="text"
                                                                    class="form-control text-center"
                                                                    @input="calculateAnnualTarget(y, x)"
                                                                    v-model="y.q3"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="text-center align-middle"
                                                            :class="{'border-2-white-top' : yIndex == 0}"
                                                            width="120px"
                                                        >
                                                            <div v-if="!y.editMode">
                                                                {{ y.q4 }}
                                                            </div>
                                                            <div v-else>
                                                                <input
                                                                    type="text"
                                                                    class="form-control text-center"
                                                                    @input="calculateAnnualTarget(y, x)"
                                                                    v-model="y.q4"
                                                                />
                                                            </div>
                                                        </td>
                                                    </template>
                                                    <td
                                                        class="text-center align-middle"
                                                        :class="{'border-2-white-top' : yIndex == 0}"
                                                    >
                                                        <template v-if="allowText">
                                                            <div v-if="!y.editMode">
                                                                {{ y.cascadedTargetText }}
                                                            </div>
                                                            <div v-else>
                                                                <textarea
                                                                    type="text"
                                                                    class="form-control text-center"
                                                                    rows="6"
                                                                    v-model="y.cascadedTargetText"
                                                                />
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div v-if="!y.editMode">
                                                                {{ y.cascadedTarget }}
                                                            </div>
                                                            <div v-else>
                                                                <input
                                                                    type="text"
                                                                    class="form-control text-center"
                                                                    v-model="y.cascadedTarget"
                                                                />
                                                            </div>
                                                        </template>
                                                    </td>
                                                    <td class="align-middle border-2-white" :class="{'border-2-white-top' : yIndex == 0}" rowspan="2">
                                                        <div
                                                            v-if="(!y.editMode && !y.status && fromTemplate) || (!fromTemplate && !y.editMode)"
                                                            class="d-flex justify-content-center align-items-center"
                                                        >
                                                            <button
                                                                type="button"
                                                                class="btn btn-link p-0 font-size-16 me-1"
                                                                title="Edit"
                                                                @click="updateTargetDU(x, y)"
                                                                v-if="$store.state.data.selectedCampus.id == z.campusId || !fromTemplate"
                                                            >
                                                                <i class="bx bx-edit"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                class="
                                                                    btn btn-link
                                                                    p-0
                                                                    font-size-16
                                                                "
                                                                title="Delete"
                                                                @click="removeTargetDU(x, y)"
                                                                v-if="$store.state.data.selectedCampus.id == z.campusId || !fromTemplate"
                                                            >
                                                                <i class="bx bx-trash text-danger"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                class="btn btn-link p-0 font-size-16 me-1"
                                                                title="Post"
                                                                @click="postSingle(y)"
                                                                v-if="$store.state.data.selectedCampus.id == z.campusId && fromTemplate"
                                                            >
                                                                <i class="bx bx-paper-plane  text-green"></i>
                                                            </button>
                                                        </div>
                                                        <div
                                                            v-if="y.editMode"
                                                            class="d-flex justify-content-center align-items-center"
                                                        >
                                                            <button
                                                                type="button"
                                                                class="btn btn-link p-0 me-1 text-success d-flex me-2"
                                                                title="Edit"
                                                                @click="saveDUPoint(y)"
                                                            >
                                                                <i class="bx bx-save me-1 font-size-16"></i>Save
                                                            </button>
                                                            <button
                                                                type="button"
                                                                class="btn btn-link p-0 me-1 d-flex align-items-center text-dark"
                                                                title="Edit"
                                                                @click="cancelTargetDU(y)"
                                                            >
                                                                <i class="bx bx-x me-1 font-size-16"></i>
                                                            </button>
                                                        </div>
                                                        <div v-if="y.status" class="text-center text-green">
                                                            <b>{{y.status.toUpperCase()}}</b>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr :key="`extra-A${x.id}-B${y.id}`">
                                                    <td colspan="5" class="border-2-white">
                                                        <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                            <input
                                                                type="checkbox"
                                                                id="customCheckcolor2"
                                                                checked="checked"
                                                                class="form-check-input"
                                                                v-model="y.allowEdit"
                                                                :disabled="!y.editMode"
                                                            /><label
                                                                for="customCheckcolor2"
                                                                class="form-check-label"
                                                            >
                                                                Allow Edit
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
</template>